import { IXmlNode } from '@/app-modules/server-communications';
import { safeCast } from '@/helper';

class HamsterRaceInfoData {
    public lastEightWinners: number[];
    public hamsterStats: HamsterStats[];

    constructor(node: IXmlNode) {
        this.lastEightWinners = this.getLastEightWinners(node);
        this.hamsterStats = this.getHamsterStats(node);
    }

    private getLastEightWinners(node: IXmlNode): number[] {
        const lastEightWinnersAsString = node.childNodes.hamsterset[0].childNodes.last8[0].attributes.hams;

        return lastEightWinnersAsString
                .split('')
                .map((x) => parseInt(x, 10));
    }

    private getHamsterStats(node: IXmlNode): HamsterStats[] {
        const hamsterStats: HamsterStats[] = [];
        const hamsterStatsArray = node.childNodes.hamsterset[0].childNodes.last100[0].childNodes.hamster;

        hamsterStatsArray.forEach((hamster) => {
            hamsterStats.push(new HamsterStats(hamster));
        });

        return hamsterStats;
    }
}

interface IHamsterStats {
    hamsterId: number;
    hamsterName: string;
    racesWon: number;
}

class HamsterStats implements IHamsterStats {
    public hamsterId: number;
    public racesWon: number;
    public hamsterName: string;

    constructor(messageNode: IXmlNode) {
        this.hamsterId = safeCast(messageNode.attributes.ham, 0);
        this.racesWon = safeCast(messageNode.attributes.races, 0);
    }
}

export { HamsterRaceInfoData, IHamsterStats };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/hamster-race-info/hamster-race-info-data.ts